export const environment = {
    production: false,
    //api_URL: 'http://localhost:3000/',
    api_URL: 'https://api.codeingress.com/email/',
    api_key: '8216e982093a178babc12a3743f9c4d0'
  };
  